if (typeof G === 'undefined') G = {};
G.UI = G.UI || {};

G.UI.createGroup = function createGroup(game, width, height, optName) {

  // imports
  var ElementType = G.UI.ElementType;
  var createUIElement = G.UI.createUIElement;

  //

  return createUIElement(game, {
      version: 1,
      desiredSize: [width, height],
      rootElement: {
          type: ElementType.Group,
          name: optName || 'rootElement'
      }
  }).rootElement;
};

/**
 * @param {Array<String>} arr
 * @returns {function(Array<String>)}
 */
G.UI.createFilterToSkipExportNames = function createFilterToSkipExportNames(exportNamesToSkip) {
  return filter;
  function filter(exportNames) {
    return exportNames.every(function(e) {
      return exportNamesToSkip.indexOf(e) === -1;
    });
  }
};